import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    root: {
        height: '100vh'
    },
    content: {
        textAlign: 'center',
    },
    typographyTitle: {
        marginBottom: 5,
    },
    image: {
        width: 300,
        float: 'inherit',
        [theme.breakpoints.down('xs')]: {
            width: 300,
        },
    },
    gridImage: {
        textAlign: 'center',
        paddingTop: 50,
    },
}))
